/**
 * Normalize FastAPI / Axios error payloads for user-facing messages.
 */
export function getApiErrorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const ax = err as { response?: { data?: { detail?: unknown; message?: unknown } } };
    const data = ax.response?.data;
    if (data?.detail !== undefined) {
      const d = data.detail;
      if (typeof d === 'string') return d;
      if (Array.isArray(d)) {
        return d
          .map((e: unknown) =>
            typeof e === 'object' && e !== null && 'msg' in e
              ? String((e as { msg?: string }).msg)
              : JSON.stringify(e)
          )
          .join(' ');
      }
      // FastAPI detail as object (e.g. bridge platform gate: { message, validation })
      if (typeof d === 'object' && d !== null) {
        const o = d as Record<string, unknown>;
        const parts: string[] = [];
        if (typeof o.message === 'string') parts.push(o.message);
        if (o.validation !== undefined) {
          parts.push(
            typeof o.validation === 'string'
              ? o.validation
              : JSON.stringify(o.validation)
          );
        }
        if (parts.length > 0) return parts.join(' — ');
        return JSON.stringify(o);
      }
    }
    if (typeof data?.message === 'string') return data.message;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
